import React from 'react';
import "./parcoursStyle.css";
import * as FaIcons from "react-icons/fa";

class Parcours extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opacity: "0", opacity0: "0", opacity1: "0", opacity2: "0", opacity3: "0", opacity4: "0", opacity5: "0",
            time: "0", time0: "", time1: "", time2: "", time3: "", time4: "", time5: "",
            timeAnim: "", timeAnim0: "", timeAnim1: "", timeAnim2: "", timeAnim3: "", timeAnim4: "", timeAnim5: "", timeAnim6: "",
            countAnim: "infinite", countAnim0: "infinite", countAnim1: "infinite", countAnim2: "infinite", countAnim3: "infinite", countAnim4: "infinite", countAnim5: "infinite", countAnim6: "infinite",
            iconDisplay: "", iconDisplay0: "", iconDisplay1: "", iconDisplay2: "", iconDisplay3: "", iconDisplay4: "", iconDisplay5: "", iconDisplay6: ""
        }
    }
    showFormation = (e) => {
        let currentElement = (e.currentTarget.dataset.id);
        console.log(currentElement);
        switch (currentElement) {
            case "2022":
                this.setState({
                    opacity: "1", time: "0", timeAnim: "5", countAnim: 1, iconDisplay: "none"
                });
                break;
            case "2021":
                this.setState({
                    opacity0: "1", time0: "0", timeAnim0: "5", countAnim0: 2, iconDisplay0: "none"
                });
                break;
            case "2020":
                this.setState({
                    opacity1: "1", time1: "0", timeAnim1: "5", countAnim1: 3, iconDisplay1: "none"
                });
                break;
            case "2009-2011":
                this.setState({
                    opacity2: "1", time2: "0", timeAnim2: "5", countAnim2: 4, iconDisplay2: "none"
                });
                break;
            case "2008-2009":
                this.setState({
                    opacity3: "1", time3: "0", timeAnim3: "5", countAnim3: 5, iconDisplay3: "none"
                });
                break;
            case "2002-2007":
                this.setState({
                    opacity4: "1", time4: "0", timeAnim4: "5", countAnim4: 6, iconDisplay4: "none"
                });
                break;
            case "2002":
                this.setState({
                    opacity5: "1", time5: "0", timeAnim5: "5", countAnim5: 7, iconDisplay5: "none"
                });
                break;
            default: this.setState({
                opacity: "1", time: "0", timeAnim: "5", countAnim: 1, iconDisplay: "none"
            });
        }
    }
    render() {
        return (
            <div className="container-fluid pageFormations">
                <div className="container p-2">
                    <h2>Mes formations</h2>
                    <div className="row">
                        <div className="container formations">
                            <h5 className="titreFormation" data-id="2022" onClick={this.showFormation} style={{ animation: `lighton ${this.state.time}s` }}><FaIcons.FaRegHandPointDown style={{ display: this.state.iconDisplay }} />2022</h5>
                            <p className="textFormation" style={{ opacity: `${this.state.opacity}`, animation: ` glissement ${this.state.countAnim} ${this.state.timeAnim}s` }}>
                                Sogeti Academy - Globale Knowledge.
                            </p>
                        </div>
                        <div className="container formations">
                            <h5 className="titreFormation" data-id="2021" onClick={this.showFormation} style={{ animation: `lighton ${this.state.time0}s` }}><FaIcons.FaRegHandPointDown style={{ display: this.state.iconDisplay0 }} />Depuis Août 2021</h5>
                            <p className="textFormation" style={{ opacity: `${this.state.opacity0}`, animation: ` glissement ${this.state.countAnim0} ${this.state.timeAnim0}s` }}>
                                Concepteur Développeur d'applications (DORANCO Paris).
                            </p>
                        </div>
                        <div className="container formations">
                            <h5 className="titreFormation" data-id="2020" onClick={this.showFormation} style={{ animation: `lighton ${this.state.time1}s` }}><FaIcons.FaRegHandPointDown style={{ display: this.state.iconDisplay1 }} />Août 2020-mars 2021</h5>
                            <p className="textFormation" style={{ opacity: `${this.state.opacity1}`, animation: ` glissement ${this.state.countAnim1} ${this.state.timeAnim1}s` }}>
                                Développeur Web et Web Mobile (Nextformation Paris).
                            </p>
                        </div>
                        <div className="container formations">
                            <h5 className="titreFormation" data-id="2009-2011" onClick={this.showFormation} style={{ animation: `lighton ${this.state.time2}s` }}><FaIcons.FaRegHandPointDown style={{ display: this.state.iconDisplay2 }} />2009-2011</h5>
                            <p className="textFormation" style={{ opacity: `${this.state.opacity2}`, animation: ` glissement ${this.state.countAnim2} ${this.state.timeAnim2}s` }} >
                                Niveau DU, diplôme d’université (valdation de la prtie théorique), ergonomie et analyse de travail (université Pierre et Marie Curie UPMC Paris 6).
                            </p>
                        </div>
                        <div className="container formations ">
                            <h5 className="titreFormation" data-id="2008-2009" onClick={this.showFormation} style={{ animation: `lighton ${this.state.time3}s` }}><FaIcons.FaRegHandPointDown style={{ display: this.state.iconDisplay3 }} />2008-2009</h5>
                            <p className="textFormation" style={{ opacity: `${this.state.opacity3}`, animation: ` glissement ${this.state.countAnim3} ${this.state.timeAnim3}s` }} >
                                Niveau master ingénierie et management en sécurité globale appliquée (université de technologie de Troyes).
                            </p>
                        </div>
                        <div className="container formations ">
                            <h5 className="titreFormation" data-id="2002-2007" onClick={this.showFormation} style={{ animation: `lighton ${this.state.time4}s` }}><FaIcons.FaRegHandPointDown style={{ display: this.state.iconDisplay4 }} />2002-2007</h5>
                            <p className="textFormation" style={{ opacity: `${this.state.opacity4}`, animation: ` glissement ${this.state.countAnim4} ${this.state.timeAnim4}s` }}>
                                Ingénieur en hygiène et sécurité industrielle, (université de Batna, Algérie) (comparabilité ENIC-NARIC : Diplôme de
                                niveau I de la nomenclature française et niveau 7 du cadre européen des certifications) .
                            </p>
                        </div>
                        <div className="container formations">
                            <h5 className="titreFormation" data-id="2002" onClick={this.showFormation} style={{ animation: `lighton ${this.state.time5}s` }}><FaIcons.FaRegHandPointDown style={{ display: this.state.iconDisplay5 }} />2002</h5>
                            <p className="textFormation" style={{ opacity: `${this.state.opacity5}`, animation: ` glissement ${this.state.countAnim5} ${this.state.timeAnim5}s` }}>
                                BAC sciences exactes (Jijel, Algérie).
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Parcours;